var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bg-overlay"}},[_c('Sidebar'),_c('Header'),_c('v-main',{attrs:{"app":""}},[_c('div',{style:({
      'height': _vm.containerHeight,
    }),attrs:{"id":"scroll-container"}},[_c('v-container',{staticClass:"px-2 px-sm-10",style:({ 'min-height': _vm.containerHeight }),attrs:{"fluid":""}},[_c('router-view'),_c('v-sheet',{attrs:{"color":"transparent","height":`calc(${_vm.footerHeight} + 40px)`}}),_c('Footer')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }